import { gql } from "@apollo/client";

export const GET_ORDERS = gql`
query GetOrders($page: Int, $limit: Int, $filter: String, $sort: orderSort, $from: String, $to: String, $orderStatus: String, $customerId :String,$tag:String,$paymentStatus:String $dayRange:String, $paymentType:String) {
  getOrders(page: $page, limit: $limit, filter: $filter, sort: $sort, from: $from, to: $to, orderStatus: $orderStatus,customerId: $customerId,tag: $tag,paymentStatus: $paymentStatus,dayRange:$dayRange,paymentType:$paymentType) {
    count
    data {
      id
      package_weight_Length
      ProductPrice
      net_receivable_amount
      ProductName
      payment_type
      customerId
      order_number
      codCollectableValue
      total_charges
      rto_order_charge
      final_order_amount
      pickupAddress {
        name
        phone
        address1
        city
        stateId {
          id
          name
        }
        zipCode
        customerId
      }
      deliveryAddress {
        name
        phone
        address1
        city
         stateId {
          id
          name
        }
        zipCode
        customerId
      }
      stateId
      trackStatus
      order_amount
      package_weight
      isDeleted
        token
      isActive
      status
      paymentStatus
      courier_name
      manifest
      shipment_id
      order_id
      courier_id
      label
      paymentDetails
      delivery_order_Date
      awb_number
      cod_payment_status
      createdAt
      Shipment_name
      freight_charges
      cod_charges
      total_charges
      cod_charge_reversed
      rto_extra_weight_charges
      extra_weight_charges
      applied_weight
    }
  }
}
`
export const GET_PAYMENT_ORDERS = gql`
query GetPaymentOrders($page: Int, $limit: Int, $sort: orderSort, $filter: String, $from: String, $to: String, $orderStatus: String, $codPaymentStatus: String,$dayRange:String) {
  getPaymentOrders(page: $page, limit: $limit, sort: $sort, filter: $filter, from: $from, to: $to, orderStatus: $orderStatus, cod_payment_status: $codPaymentStatus,dayRange: $dayRange) {
    count
    data {
      id
      customerId
      order_number
      cod_payment_status
      final_order_amount
      net_receivable_amount
      rto_order_charge
      payment_order_Date
      pickupAddress {
        name
        phone
        address1
        city
        stateId {
          id
          name
        }
        zipCode
        customerId
      }
      deliveryAddress {
        name
        phone
        address1
        city
         stateId {
          name
        }
        zipCode
        customerId
      }
      trackStatus
      total_charges
      order_amount
      codCollectableValue
      payment_type
      package_weight
      isDeleted
      isActive
      status
      courier_name
      paymentDetails
      manifest
      shipment_id
      order_id
      courier_id
      token
      label
      warehouse_name
      awb_number
      ProductPrice
      ProductName
      createdAt
      paymentSessionId
      cfToken
      cfOrderId
      paymentStatus
      package_weight_Length
      delivery_order_Date
    }
  }
}
`
export const GET_MONTHLY_ORDERS = gql`
query DailyOrders {
  getOrderCounts {
    dailyOrders {
      count
      _id
    }
    monthlyOrders {
      _id
      count
    }
  }
}
`
export const GET_MONTHLY_ORDERS_SAME_DAY = gql`
query DailyOrders {
  getSameDayOrderCounts {
    dailyOrders {
      count
      _id
    }
    monthlyOrders {
      _id
      count
    }
  }
}
`

export const GET_User_DAILY_MONTHLY = gql`
query GetUserCounts {
  getUserCounts {
    monthlyUser {
      _id
      count
    }
    dailyUser {
      _id
      count
    }
  }
}
`
export const GET_TOTAL_COUNT_DASHBOARD = gql`
query GetDashboardCount {
  getDashboardCount {
    payment
    order
    customer
    ticket
    SameDayDeliveryOrderData
  }
}
`

export const GET_TOTAL_COUNT_TICKET = gql
  `query GetSupportCounts {
  getSupportCounts {
    monthlySupport {
      _id
      count
    }
    dailySupport {
      _id
      count
    }
  }
}`

export const GET_ORDERS_BY_ID = gql`
query GetOrder($getOrderId: String) {
  getOrder(id: $getOrderId) {
  Shipment_name
    customerId
    payment_type
    order_number
    ProductPrice
    codCollectableValue
    package_weight_Length
    ProductName
    Shipment_name
    pickupAddress {
      name
      phone
      address1
      city
      stateId {
        id
        name
      }
      zipCode
      customerId
    }
    deliveryAddress {
      name
      phone
      address1
      city
        stateId {
          id
          name
        }
      zipCode
      customerId
    }
    stateId
    trackStatus
      token
    order_amount
    package_weight
    isDeleted
    isActive
    status
    courier_name
    manifest
    shipment_id
    order_id
    courier_id
    label
    awb_number
    createdAt
    paymentDetails
    id
  }
}
  `

export const GETTURNOVER = gql`
  query OrderAmountTotals {
  orderAmountTotals {
    dailyTotal
    monthlyTotal
    yearlyTotal  
  }
}
  `
export const GET_NETAMOUNT = gql`
  query OrderNetAmountTotals {
  orderNetAmountTotals {
    dailyTotal
    monthlyTotal
    yearlyTotal
  }
}
  `

export const GETNETAMOUNT = gql`
 query GetOrderWithNetAmount($page: Int, $sort: orderSort, $limit: Int, $filter: String, $from: String, $to: String) {
  GetOrderWithNetAmount(page: $page, sort: $sort, limit: $limit, filter: $filter, from: $from, to: $to) {
    orders {
      createdAt
      netAmount
      order_number
      thirdPartyAmount
      order_amount
      cashFreeAmount
      courierAmount
      status
      paymentDetails
      awb_number
    }
    count
    totalNetAmount
  ThirdPartyNetAmount
  ThirdCashFreeNetAmount
  TotalTurnOver
  }
}
  `

export const GET_FOUR_DAY_ORDER_PAYMENT = gql`
query GetAfterFourDayOfDeliveryOrder($page: Int, $limit: Int, $filter: String, $sort: orderSort, $from: String, $to: String, $isOpenTodayPayment: Boolean, $paymentStatus: String,$email:String) {
  getAfterFourDayOfDeliveryOrder(page: $page, limit: $limit, filter: $filter, sort: $sort, from: $from, to: $to, isOpenTodayPayment: $isOpenTodayPayment, paymentStatus: $paymentStatus,email:$email) {
    count
    data {
      customerId
      email
      totalPayAmount
      isOpenTodayPayment
      orders
    }
  }
}
`

export const GET_ORDER_FOR_PAYMENT = gql`
query GetCustomerPendingPaymentOrder($paymentStatus: String, $orderStatus: String, $customerId: String, $to: String, $from: String, $sort: orderSort, $page: Int, $limit: Int, $filter: String,$cod_payment_status:String,$dayRange:String) {
  getCustomerPendingPaymentOrder(paymentStatus: $paymentStatus, orderStatus: $orderStatus, customerId: $customerId, to: $to, from: $from, sort: $sort, page: $page, limit: $limit, filter: $filter,cod_payment_status:$cod_payment_status,dayRange:$dayRange) {
    count
    data {
      id
      customerId
      dayDifference
      order_number
      cod_payment_status
      final_order_amount
      net_receivable_amount
      delivery_order_Date
      rto_order_charge
      pickupAddress {
        name
        phone
        address1
        city
        stateId {
          id
          name
        }
        zipCode
        customerId
      }
      deliveryAddress {
        name
        phone
        address1
        city
        zipCode
        customerId
      }
      stateId
      trackStatus
      total_charges
      order_amount
      codCollectableValue
      payment_type
      package_weight
      isDeleted
      isActive
      payment_order_Date
      status
      courier_name
      paymentDetails
      manifest
      shipment_id
      order_id
      courier_id
      token
      label
      warehouse_name
      awb_number
      ProductPrice
      ProductName
      createdAt
      paymentSessionId
      cfToken
      isOpenTodayPayment
      paymentStatus
      package_weight_Length
    }
  }
}
`

export const AFTER_FOURDAY_NOT_PAYMENT_ORDER = gql`
query GetAfterNotPaymentDeliveryOrder($paymentStatus: String, $isOpenTodayPayment: String, $to: String, $from: String, $sort: orderSort, $page: Int, $limit: Int, $filter: String,$email:String) {
  getAfterNotPaymentDeliveryOrder(paymentStatus: $paymentStatus, isOpenTodayPayment: $isOpenTodayPayment, to: $to, from: $from, sort: $sort, page: $page, limit: $limit, filter: $filter,email:$email) {
    count
    data {
      customerId
      email
      totalPayAmount
      isOpenTodayPayment
    }
  }
}
`
export const IS_OPEN_TODAY_PICKUP_ORDER = gql`
query GetOpenTodayPickupOrder( $page: Int,$email: String, $isOpenTodayPickup: String,  $sort: orderSort, $limit: Int) {
  getOpenTodayPickupOrder(page: $page,email: $email, isOpenTodayPickup: $isOpenTodayPickup,  sort: $sort, limit: $limit) {
    count
    data {
      customerId
      email
      isOpenTodayPickup
      totalOrders
    }
  }
}
`
export const GET_OPEN_TODAY_PICKUP_ORDER_LIST = gql`
query GetOpenTodayPickupOrderList($sort: orderSort, $page: Int, $limit: Int, $filter: String, $from: String, $to: String, $isOpenTodayPickup: String, $dayRange: String, $paymentType: String, $customerId: String, $orderStatus: String) {
  getOpenTodayPickupOrderList(sort: $sort, page: $page, limit: $limit, filter: $filter, from: $from, to: $to, isOpenTodayPickup: $isOpenTodayPickup, dayRange: $dayRange, paymentType: $paymentType, customerId: $customerId, orderStatus: $orderStatus) {
    count
    data {
      id
      customerId
      order_number
      delivery_order_Date
      cod_payment_status
      final_order_amount
      net_receivable_amount
      rto_order_charge
      pickupAddress {
        name
        phone
        address1
        city
        stateId {
          id
          name
        }
        zipCode
        customerId
      }
      deliveryAddress {
        name
        phone
        address1
        city
        zipCode
        customerId
      }
      stateId
      dayDifference
      trackStatus
      total_charges
      order_amount
      codCollectableValue
      payment_type
      package_weight
      isDeleted
      isActive
      payment_order_Date
      status
      courier_name
      paymentDetails
      manifest
      shipment_id
      order_id
      courier_id
      token
      label
      warehouse_name
      awb_number
      ProductPrice
      ProductName
      createdAt
      paymentSessionId
      cfToken
      isOpenTodayPayment
      isOpenTodayPickup
      paymentStatus
      package_weight_Length
    }
  }
}
`
export const GET_ORDERS_CUSTOMER_FOR_ADMIN = gql`
query GetCustomerOrdersAllForAdmin($paymentType: String, $dayRange: String, $deliveryDate: String, $customerId: String, $orderStatus: String, $to: String, $from: String, $page: Int, $limit: Int, $filter: String, $sort: orderSort,$codPaymentStatus:String) {
  getCustomerOrdersAllForAdmin(paymentType: $paymentType, dayRange: $dayRange, deliveryDate: $deliveryDate, customerId: $customerId, orderStatus: $orderStatus, to: $to, from: $from, page: $page, limit: $limit, filter: $filter, sort: $sort,codPaymentStatus:$codPaymentStatus) {
    count
    data {
      id
      order_number
      delivery_order_Date
      cod_payment_status
      final_order_amount
      net_receivable_amount
      rto_order_charge
      pickupAddress {
        name
        phone
        address1
        city
        stateId {
          id
          name
        }
        zipCode
        customerId
      }
      deliveryAddress {
        name
        phone
        address1
        city
        zipCode
        customerId
      }
      stateId
      dayDifference
      trackStatus
      total_charges
      order_amount
      codCollectableValue
      payment_type
      package_weight
      isDeleted
      isActive
      payment_order_Date
      status
      courier_name
      paymentDetails
      order_id
      awb_number
      ProductPrice
      ProductName
      createdAt
      isOpenTodayPayment
      isOpenTodayPickup
      paymentStatus
      package_weight_Length
    }
  }
}
`

export const GET_NDR_LIST = gql`
query GetNDRList($page: Int, $limit: Int, $filter: String, $sort: userSort, $paymentType: String, $status: String, $to: String, $from: String, $search: String) {
  getNDRList(page: $page, limit: $limit, filter: $filter, sort: $sort, paymentType: $paymentType, status: $status, to: $to, from: $from, search: $search) {
    count
    data {
      id
      order_number
      pickupAddress {
        name
        phone
        address1
        city
       
        zipCode
      }
      deliveryAddress {
        name
        phone
        address1
        city
        zipCode
         stateId {
          id
          name
        }
      }
      order_amount
      payment_type
      status
      order_id
      awb_number
      ProductPrice
      ProductName
      createdAt
       ndr_history {
        event_date
        courier_remarks
        total_attempts
        user_action
        By
      }
    }
  }
}
`

export const GET_ORDER_COUNT = gql`
query GetOrderStatusCounts($paymentType: String, $paymentStatus: String, $filter: String, $from: String, $to: String, $dayRange: String, $tag: String, $orderStatus: String) {
  getOrderStatusCounts(paymentType: $paymentType, paymentStatus: $paymentStatus, filter: $filter, from: $from, to: $to, dayRange: $dayRange, tag: $tag, orderStatus: $orderStatus) {
    statusCounts {
      booked
      pendingpickup
      intransit
      outfordelivery
      delivered
      cancelled
    }
  }
}
`

export const GET_NDR_COUNT = gql`
query GetNDRCounts($filter: String, $from: String, $to: String, $paymentType: String) {
  getNDRCounts(filter: $filter, from: $from, to: $to, paymentType: $paymentType) {
    actionRequiredCount
    actionRequestedCount
    rtoCount
    deliveredCount
  }
}
`

export const GET_SHIPPING_RATE = gql`
query GetShippingRate($pincode: Int!, $weight: Float!) {
  getShippingRate(pincode: $pincode, weight: $weight) {
    perKgPrice
    totalPrice
  }
}
`